export default "__VITE_ASSET__By5Y6eoj__"